export const getInitials = (string: string, glue = true) => {
	const initials = string.replace(/[^a-zA-Z- ]/g, '').match(/\b\w/g);

	if (initials && glue) {
		return initials.join('');
	}

	return initials;
};
